import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=7a1a4a9c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a1a4a9c')) {
      api.createRecord('7a1a4a9c', component.options)
    } else {
      api.reload('7a1a4a9c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=7a1a4a9c", function () {
      api.rerender('7a1a4a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/Sidebar.vue"
export default component.exports